import React from 'react';
import { LockIcon, MailIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
interface TrustBadgesProps {
  variant: 'horizontal' | 'grid';
  className?: string;
}
export function TrustBadges({
  variant,
  className = ''
}: TrustBadgesProps) {
  const badges = [{
    icon: LockIcon,
    text: 'Secure Payment'
  }, {
    icon: MailIcon,
    text: 'Instant Email Access'
  }, {
    icon: ShieldCheckIcon,
    text: '7-Day Money Back'
  }, {
    icon: CreditCardIcon,
    text: 'Secure Checkout'
  }];
  if (variant === 'grid') {
    return <div className={`grid grid-cols-2 gap-4 ${className}`} data-id="element-84">
        {badges.map((badge, idx) => <div key={idx} className="flex items-center justify-center space-x-2 text-softgray" data-id="element-85">
            <badge.icon className="w-4 h-4 text-rosegold" data-id="element-86" />
            <span className="text-xs font-inter" data-id="element-87">{badge.text}</span>
          </div>)}
      </div>;
  }
  return <div className={`flex flex-wrap items-center justify-center gap-4 md:gap-8 ${className}`} data-id="element-88">
      {badges.map((badge, idx) => <div key={idx} className="flex items-center space-x-2 text-softgray" data-id="element-89">
          <badge.icon className="w-4 h-4 text-rosegold" data-id="element-90" />
          <span className="text-xs md:text-sm font-inter" data-id="element-91">{badge.text}</span>
        </div>)}
    </div>;
}